// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faTwitter as fabFaTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faFacebookF as fabFaFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faXTwitter as fabFaXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faInstagram as fabFaInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faYoutube as fabFaYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";

import { faCaretDown as fasFaCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faPhone as fasPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";

import { faEnvelope as falFaEnvelope } from "@fortawesome/pro-light-svg-icons/faEnvelope";
import { faUser as falFaUser } from "@fortawesome/pro-light-svg-icons/faUser";

/**
 * Add brand icons
 */
library.add(fabFaTwitter, fabFaFacebookF, fabFaInstagram, fabFaYoutube, fabFaXTwitter);

/**
 * Add solid icons
 */
library.add(fasFaCaretDown, fasPhone);

/**
 * Add light icons
 */
library.add(falFaEnvelope, falFaUser);

/**
 * Watch the DOM to insert icons
 */
dom.watch();
